import { projectTreeItemTypeOptions } from '../../../../../react-query/project/query/use-get-project-tree-query'
import { SpinnerGrey } from '../../../../../components/stories/atoms/icons/special'
import { iconSizeOptions } from '../../../../../components/stories/atoms/icons/icons-sizes'
import {
  BodyTd,
  BodyTr
} from '../../../../../components/stories/organisms/table/styled-components'
import { PlanMenuTableStatusContent } from '../../../styled-component'

export const PlanMenuTableStatusRow = ({ children, colSpan }) => (
  <BodyTr>
    <BodyTd colSpan={colSpan}>
      <PlanMenuTableStatusContent>{children}</PlanMenuTableStatusContent>
    </BodyTd>
  </BodyTr>
)

export const PlanMenuFolderStatusRow = ({
  childrenByFolderId,
  colSpan,
  folderChildrenStateById,
  formatMessage,
  row
}) => {
  if (row.original.type !== projectTreeItemTypeOptions.FOLDER) return null
  if (!row.getIsExpanded()) return null

  const query = folderChildrenStateById.get(row.original.id)

  if (query?.isLoading || query?.isFetching) {
    return (
      <PlanMenuTableStatusRow colSpan={colSpan}>
        <SpinnerGrey size={iconSizeOptions['ICON-M']} />
      </PlanMenuTableStatusRow>
    )
  }

  if (query?.isError) {
    return (
      <PlanMenuTableStatusRow colSpan={colSpan}>
        {formatMessage({
          id: 'moveItems_move_error',
          defaultMessage: 'Unable to load this folder'
        })}
      </PlanMenuTableStatusRow>
    )
  }

  if (query?.isFetched && !childrenByFolderId.get(row.original.id)?.length) {
    return (
      <PlanMenuTableStatusRow colSpan={colSpan}>
        {formatMessage({
          id: 'plans_folderEmpty',
          defaultMessage: 'No plans here'
        })}
      </PlanMenuTableStatusRow>
    )
  }

  return null
}
